import axios from 'axios'

// iniciardor de objeto
const redes = {
  trongrid: {
    fullNode: 'https://api.trongrid.io',
    solidityNode: 'https://api.trongrid.io',
    eventServer: 'https://api.trongrid.io'
  },
  shasta: {
    fullNode: 'https://api.shasta.trongrid.io',
    solidityNode: 'https://api.shasta.trongrid.io',
    eventServer: 'https://api.shasta.trongrid.io'
  },
  nile: {
    fullNode: 'https://api.nileex.io',
    solidityNode: 'https://api.nileex.io',
    eventServer: 'https://event.nileex.io'
  },
  local: {
    fullNode: 'http://127.0.0.1:9090',
    solidityNode: 'http://127.0.0.1:9090',
    eventServer: 'http://127.0.0.1:9090'
  }
}

export default class ApiWallet {
  constructor () {
    this.readOnly = true
    const TronWeb = require('tronweb')
    const TronGrid = require('trongrid')
    const HttpProvider = TronWeb.providers.HttpProvider
    const red = redes.trongrid
    // console.log('tronWeb', window.tronWeb.fullNode.host)
    if (window.tronWeb && window.tronWeb.fullNode.host === red.fullNode) {
      this.readOnly = false
      this.tronWeb = window.tronWeb
    } else {
      this.privateKey = ''
      this.tronWeb = new TronWeb(
        new HttpProvider(red.fullNode),
        new HttpProvider(red.solidityNode),
        new HttpProvider(red.eventServer),
        ''
      )
      this.setAddress('')
    }
    this.tronGrid = new TronGrid(this.tronWeb)
  }

  setAddress (address) {
    this.tronWeb.setAddress(address && address !== '' ? address : 'TTSrcwTx2kpKw51SKL58YzYVHo9Kg8D2JS')
  }

  setPrivateKey (PrivateKey) {
    this.tronWeb.setPrivateKey(PrivateKey)
    this.tronGrid.setExperimental(PrivateKey)
  }

  async getAccount () {
    return await this.tronWeb.trx.getAccount()
      .then(resp => Promise.resolve(resp))
      .catch(error => Promise.resolve(error))
  }

  async getTransactions (address) {
    const options = {
      /* only_to: false,
      only_from: false,
      */
      only_confirmed: false,
      limit: 50,
      order_by: 'timestamp,desc',
      min_timestamp: Date.now() - 60 * 60 * 60 * 60 * 1000 // from a minute ago to go on
    }
    // awaiting
    return await this.tronGrid.account.getTransactions(address, options)
  }

  /* doc. https://developers.tron.network/reference/trc20-transaction-information-by-account-address */
  async getTransactionsTRC20 (address, options) {
    // awaiting transferencias entre address y contrato
    return await axios({
      method: 'get',
      url: 'https://' + 'api' + '.' + 'trongrid.io/v1/accounts/' + address + '/transactions/trc20',
      params: options
    })
  }

  /* transaciones trx de la address sobre el contrato */
  async getTransactionsTRX (address, options) {
    // awaiting
    return await this.tronGrid.account.getTransactions(address, options)
  }

  async getEventByContract (address, eventName) {
    // awaiting
    return await axios({
      method: 'get',
      url: 'https://' + 'api' + '.' + 'trongrid.io/v1/contracts/' + address + '/events',
      params: {
        event_name: eventName,
        limit: 9,
        only_unconfirmed: false,
        only_confirmed: false
      }
    })
  }

  // todas las transaciones dentro del contrato
  async getTransactionsByContractTRX (address) {
    // awaiting
    return await axios({
      method: 'get',
      url: 'https://api.trongrid.io/v1/contracts/' + address + '/transactions',
      params: {
        search_internal: false,
        only_confirmed: true,
        limit: 100
      }
    })
  }

  async getContract (address) { return await this.tronWeb.contract().at(address) }

  async balanceTRC20 (
    TRC20,
    address
  ) {
    let balance = 0
    await this.getContract(TRC20)
      .then(async resp => {
        await resp.balanceOf(address).call()
          .then(async resp => {
            balance = this.tronWeb.toDecimal(resp)
          }).catch(e => Promise.reject(e))
      }).catch(e => console.log('error', e))
    return balance
  }

  // gettransactionbyid
  async gettransactionbyid (hash) {
    return await axios({
      url: 'https://apilist.tronscan.org/api/transaction-info',
      method: 'get',
      params: {
        hash: hash
      }
    })
  }

  // gettransactionbyid
  async getEventByID (hash) {
    return await axios({
      url: 'https://api.trongrid.io/v1/transactions/' + hash + '/events',
      method: 'get'
    })
  }

  // TRC20
  async balanceOf (instance, address) {
    let balance = 0
    await instance.balanceOf(address).call()
      .then(resp => {
        balance = this.tronWeb.toDecimal(resp._hex)
      }).catch(e => console.log('error', e))
    return balance
  }

  // approve
  async approve (instance, spender, value) {
    return await instance.approve(
      spender,
      value
    ).send({
      feeLimit: 10000000,
      callValue: 0,
      shouldPollResponse: false
    })
  }

  // autirizacion
  async allowance (
    instance,
    owner,
    spender
  ) {
    let allowance = 0
    await instance.allowance(owner, spender).call()
      .then(resp => {
        allowance = this.tronWeb.toDecimal(resp._hex)
      }).catch(e => console.log('error', e))
    return allowance
  }
}
